// components/AIDashboard.js
import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { 
    FaShoppingBag, 
    FaTruck, 
    FaUndo, 
    FaClock,
    FaMicrophone,
    FaTrash,
    FaUser,
    FaStore
} from 'react-icons/fa';
import { IoSend } from 'react-icons/io5';
import { MdOutlineSmartToy } from 'react-icons/md';
import './style/Ai-deshboard.css'; // External CSS

const AIDashboard = () => {
    
    const api = "https://mkbackend-production.up.railway.app"
    const [loading, setLoading] = useState(false);
    const [chatMessages, setChatMessages] = useState([]);
    const [chatInput, setChatInput] = useState('');
    const [userShopId, setUserShopId] = useState(null);
    const [ userToken,setUserToken] = useState(null);
    const [isTyping, setIsTyping] = useState(false);
    const [showSuggestions, setShowSuggestions] = useState(true);

    // 🔥 REF FOR SCROLLING
    const messagesEndRef = useRef(null);

    useEffect(() => {
        // 🔥 Get both user and token from localStorage
        const userData = localStorage.getItem("user");
const user = userData && userData !== "undefined"
  ? JSON.parse(userData)
  : null;

const token = localStorage.getItem("token");

        console.log("User from localStorage:", user);
        console.log("Token from localStorage:", token);
        
        if (user && user._id) {
            setUserShopId(user._id);
        }
        if (token) {
            setUserToken(token);
        }
        
        // Add welcome message
        setChatMessages([
            {
                text: "👋 Assalam o Alaikum! I'm your AI Shopping Assistant.\n\nI can help you with:\n• Finding products (e.g., 'Show me shoes')\n• Checking order status\n• Returns & refunds\n• Delivery information\n• Price optimization (e.g., 'Optimize my prices')\n\nHow can I help you today?",
                sender: 'bot'
            }
        ]);
    }, []);

    // 🔥 AUTO SCROLL TO BOTTOM
    useEffect(() => {
        messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, [chatMessages]);

    // ===== CHATBOT =====
    const sendChatMessage = async () => {
        if (!chatInput.trim()) return;

        // 🔥 Check if user is logged in for certain features
       const userData = localStorage.getItem("user");
const user = userData && userData !== "undefined"
  ? JSON.parse(userData)
  : null;

const token = localStorage.getItem("token");
        // Check if trying to use price optimization without login
        const msg = chatInput.toLowerCase();
        if ((msg.includes('optimize') || msg.includes('price') || msg.includes('pricing')) && !token) {
            setChatMessages(prev => [...prev, {
                text: "🔐 Please login first to use price optimization!\n\n💡 Don't have an account? Sign up now to start selling!",
                sender: 'bot'
            }]);
            setChatInput('');
            return;
        }

        const userMessage = { text: chatInput, sender: 'user' };
        setChatMessages(prev => [...prev, userMessage]);
        setChatInput('');
        setLoading(true);
        setIsTyping(true);
        setShowSuggestions(false);

        try {
            // 🔥 Send both userId AND token in headers
            const response = await axios.post(
                `${api}/chat`,
                {
                    message: chatInput,
                    userId: userShopId  // userId from localStorage
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`  // 🔥 Token in headers
                    }
                }
            );

            const botMessage = {
                text: response.data.reply || "I didn't understand that. Please try asking something else.",
                sender: 'bot'
            };
            setChatMessages(prev => [...prev, botMessage]);
        } catch (error) {
            console.error('Chat error:', error);
            setChatMessages(prev => [...prev, {
                text: "😅 Sorry, I'm having trouble responding. Please try again later.",
                sender: 'bot'
            }]);
        } finally {
            setLoading(false);
            setIsTyping(false);
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            sendChatMessage();
        }
    };

    const clearChat = () => {
        setChatMessages([
            {
                text: "👋 Chat cleared! How can I help you?",
                sender: 'bot'
            }
        ]);
        setShowSuggestions(true);
    };

    const quickSuggestion = (text) => {
        setChatInput(text);
        setTimeout(() => sendChatMessage(), 100);
    };

    const isHtml = (text) => {
        return text && (text.includes('<a') || text.includes('<b') || text.includes('<br'));
    };

    return (
        <div className="ai-dashboard">
            {/* Header */}
            <div className="ai-header">
                <div className="header-content">
                    <div className="header-left">
                        <div className="bot-icon-wrapper">
                            <MdOutlineSmartToy className="bot-icon" />
                        </div>
                        <div>
                            <h1 className="header-title">AI Shopping Assistant</h1>
                            <p className="header-subtitle">
                                <span className="status-dot"></span>
                                Online • Ready to help
                            </p>
                        </div>
                    </div>
                    <div className="header-actions">
                        <button onClick={clearChat} className="clear-btn" title="Clear Chat">
                            <FaTrash />
                        </button>
                    </div>
                </div>
            </div>

            {/* Chat Container */}
            <div className="chat-container">
                <div className="chat-messages" id="chatMessages">
                    {chatMessages.map((msg, index) => (
                        <div
                            key={index}
                            className={`message-wrapper ${msg.sender === 'user' ? 'user-message-wrapper' : 'bot-message-wrapper'}`}
                        >
                            <div className="message-avatar">
                                {msg.sender === 'user' ? (
                                    <FaUser className="avatar-icon user-avatar" />
                                ) : (
                                    <MdOutlineSmartToy className="avatar-icon bot-avatar" />
                                )}
                            </div>
                            <div className={`message-content ${msg.sender === 'user' ? 'user-message' : 'bot-message'}`}>
                                {msg.sender === 'bot' && (
                                    <div className="message-sender">
                                        <MdOutlineSmartToy className="sender-icon" />
                                        <span>AI Assistant</span>
                                    </div>
                                )}
                                
                                {msg.sender === 'bot' && isHtml(msg.text) ? (
                                    <div 
                                        className="chat-html-content"
                                        dangerouslySetInnerHTML={{ 
                                            __html: msg.text
                                        }}
                                    />
                                ) : (
                                    <div className="message-text">{msg.text}</div>
                                )}
                                
                                <div className="message-time">
                                    {new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                                </div>
                            </div>
                        </div>
                    ))}
                    
                    {isTyping && (
                        <div className="message-wrapper bot-message-wrapper">
                            <div className="message-avatar">
                                <MdOutlineSmartToy className="avatar-icon bot-avatar" />
                            </div>
                            <div className="message-content bot-message">
                                <div className="typing-indicator">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </div>
                            </div>
                        </div>
                    )}
                    
                    {/* 🔥 REF FOR SCROLLING */}
                    <div ref={messagesEndRef} />
                </div>

                {/* Quick Suggestions */}
                {showSuggestions && chatMessages.length < 3 && (
                    <div className="quick-suggestions">
                        <p className="suggestions-title">Quick Suggestions</p>
                        <div className="suggestions-grid">
                            <button onClick={() => quickSuggestion('Show me products')} className="suggestion-btn">
                                <FaShoppingBag />
                                Browse Products
                            </button>
                            <button onClick={() => quickSuggestion('Optimize my prices')} className="suggestion-btn">
                                <FaStore />
                                Optimize Prices
                            </button>
                            <button onClick={() => quickSuggestion('Check my order status')} className="suggestion-btn">
                                <FaTruck />
                                Order Status
                            </button>
                            <button onClick={() => quickSuggestion('What is your return policy?')} className="suggestion-btn">
                                <FaUndo />
                                Return Policy
                            </button>
                            <button onClick={() => quickSuggestion('When will I get delivery?')} className="suggestion-btn">
                                <FaClock />
                                Delivery Time
                            </button>
                        </div>
                    </div>
                )}
            </div>

            {/* Input Area */}
            <div className="chat-input-area">
                <div className="input-container">
                    <button className="input-action-btn" title="Voice input">
                        <FaMicrophone />
                    </button>
                    <input
                        type="text"
                        value={chatInput}
                        onChange={(e) => setChatInput(e.target.value)}
                        onKeyPress={handleKeyPress}
                        placeholder="Type your message..."
                        className="chat-input"
                        disabled={loading}
                    />
                    <button
                        onClick={sendChatMessage}
                        disabled={loading || !chatInput.trim()}
                        className={`send-btn ${!chatInput.trim() ? 'disabled' : ''}`}
                    >
                        {loading ? (
                            <div className="spinner"></div>
                        ) : (
                            <IoSend />
                        )}
                    </button>
                </div>
                <div className="input-footer">
                    <span className="footer-text">Press Enter to send</span>
                    <span className="footer-text">•</span>
                    <span className="footer-text">Powered by AI</span>
                </div>
            </div>
        </div>
    );
};

export default AIDashboard;